<template>
  <router-link to="/modul-belajar" tag="li"><a><i class="fa fa-book"></i><span>Modul Belajar</span></a></router-link>
</template>
<script>
export default
{
  name: 'module-nav'
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?8640b902